import { makeAutoObservable } from "mobx";

export default class RegulationsStore {
	constructor() {
		this._regulations = [];

		this._regulationsPage = 1;
		this._regulationsTotalCount = 0;
		this._regulationsLimit = 10;

		makeAutoObservable(this);
	}

	setRegulations(regulations) {
		this._regulations = regulations;
	}

	get regulations() {
		return this._regulations;
	}

	setRegulationsPage(page) {
		this._regulationsPage = page;
	}

	get regulationsPage() {
		return this._regulationsPage;
	}

	setRegulationsTotalCount(count) {
		this._regulationsTotalCount = count;
	}

	get regulationsTotalCount() {
		return this._regulationsTotalCount;
	}

	setRegulationsLimit(limit) {
		this._regulationsLimit = limit;
	}

	get regulationsLimit() {
		return this._regulationsLimit;
	}
}
